const DAY_MS = 86_400_000;
const FORWARD_WEEKS = 104;

// Calendar dates are calculated in UTC so elapsed days and month boundaries do
// not drift across a browser's daylight-saving transition.
export function pigBreedingTimelineRange(today: string, retainedStart?: string) {
  const current = new Date(today + 'T00:00:00Z');
  const historyMonth = new Date(Date.UTC(current.getUTCFullYear(), current.getUTCMonth() - 13, 1));
  const lastDay = new Date(Date.UTC(historyMonth.getUTCFullYear(), historyMonth.getUTCMonth() + 1, 0)).getUTCDate();
  historyMonth.setUTCDate(Math.min(current.getUTCDate(), lastDay));
  const rollingStart = historyMonth.toISOString().slice(0, 10);
  // Retain an earlier context start, but never let it hide the rolling history.
  const start = retainedStart && retainedStart < rollingStart ? retainedStart : rollingStart;

  // Preserve the old Today control's forward endpoint independently of the
  // history extension. It also includes the old initial (two-month-back) range.
  const endDate = new Date(Date.UTC(current.getUTCFullYear(), current.getUTCMonth() - 1, 1));
  endDate.setUTCDate(endDate.getUTCDate() + FORWARD_WEEKS * 7);
  const end = endDate.toISOString().slice(0, 10);
  const totalDays = (Date.parse(end) - Date.parse(start)) / DAY_MS;
  return {start, end, totalDays, weeks: Math.ceil(totalDays / 7)};
}
